import { Helmet } from 'react-helmet-async';

const seoData = {
  home: {
    title: 'LBR Distribution | UK Film Distribution & Sales Agents',
    description: 'Leading UK film distribution company and film sales agents. Get your independent film on Amazon Prime, Apple TV, Tubi & more. 70% revenue to filmmakers. Professional VOD distribution across the United Kingdom.',
    keywords: 'UK film distributor, film distribution UK, film sales agents UK, VOD distribution, independent film distribution, documentary distribution UK'
  },
  distribution: {
    title: 'VOD Film Distribution UK | Amazon, Apple TV, Tubi | LBR Distribution',
    description: 'Professional VOD distribution for independent filmmakers in the UK. Get your film on Amazon Prime Video, Apple TV, Tubi, Plex & Fandango. 70% revenue share, no hidden fees.',
    keywords: 'VOD distribution UK, film distribution services, Amazon Prime distribution, Apple TV distribution, independent film distributor UK, documentary distribution'
  },
  sales: {
    title: 'UK Film Sales Agents | International Film Sales | LBR Distribution',
    description: 'Expert UK film sales agents representing independent films at Cannes, Berlin, AFM & Toronto. Secure theatrical, broadcast & streaming deals worldwide.',
    keywords: 'film sales agents UK, international film sales, theatrical distribution, film market representation, Cannes film market, film licensing UK'
  },
  films: {
    title: 'Our Film Catalogue | Distributed Films & Documentaries | LBR Distribution',
    description: 'Explore our curated catalogue of distributed films and documentaries. From award-winning horror to compelling dramas, discover quality independent cinema.',
    keywords: 'distributed films UK, independent films, documentary catalogue, horror films, film catalogue'
  },
  marketing: {
    title: 'Film Marketing Agency UK | Posters, Trailers & Campaigns | LBR Distribution',
    description: 'Full-service film marketing agency in the UK. Professional poster design, trailer production, social media campaigns & advertising for independent filmmakers.',
    keywords: 'film marketing UK, movie poster design, trailer production, film advertising, social media marketing films'
  },
  contact: {
    title: 'Contact Us | UK Film Distribution Enquiries | LBR Distribution',
    description: 'Get in touch with LBR Distribution for film distribution and sales enquiries. Based in Manchester, serving filmmakers across the United Kingdom.',
    keywords: 'contact film distributor, UK film distribution enquiry, film sales contact'
  },
  submit: {
    title: 'Submit Your Film | Film Distribution Submission | LBR Distribution',
    description: 'Submit your completed film or documentary for distribution consideration. We accept feature films and documentaries from filmmakers worldwide.',
    keywords: 'submit film for distribution, film submission UK, documentary submission, independent film submission'
  },
  faq: {
    title: 'FAQ | Film Distribution Questions Answered | LBR Distribution',
    description: 'Frequently asked questions about film distribution, VOD platforms, revenue sharing, and working with LBR Distribution as your UK film distributor.',
    keywords: 'film distribution FAQ, VOD distribution questions, film sales FAQ, distributor questions'
  }
};

export const PageSEO = ({ page, customTitle, customDescription }) => {
  const data = seoData[page] || seoData.home;
  const titleText = customTitle || data.title;
  const descriptionText = customDescription || data.description;

  return (
    <Helmet
      title={titleText}
      meta={[
        { name: 'description', content: descriptionText },
        { name: 'keywords', content: data.keywords },
        { property: 'og:title', content: titleText },
        { property: 'og:description', content: descriptionText },
        { name: 'twitter:title', content: titleText },
        { name: 'twitter:description', content: descriptionText },
      ]}
    />
  );
};

export const FilmSEO = ({ film }) => {
  if (!film) return null;
  
  const titleText = `${film.title} (${film.year}) | Watch Now | LBR Distribution`;
  const descriptionText = `${film.synopsis} Directed by ${film.director}. Available on ${film.platforms?.join(', ') || 'streaming platforms'}.`;

  return (
    <Helmet
      title={titleText}
      meta={[
        { name: 'description', content: descriptionText },
        { property: 'og:title', content: titleText },
        { property: 'og:description', content: descriptionText },
        { property: 'og:image', content: film.poster_url },
        { property: 'og:type', content: 'video.movie' },
        { name: 'twitter:title', content: titleText },
        { name: 'twitter:description', content: descriptionText },
        { name: 'twitter:image', content: film.poster_url },
      ]}
    />
  );
};

export default PageSEO;
